import gql from 'graphql-tag';

export const ShareAndRestrictButtonSpaceOverviewQuery = gql`
	query ShareAndRestrictButtonSpaceOverviewQuery($cloudId: ID!, $spaceKey: String!) {
		spaceHomepage(spaceKey: $spaceKey) {
			id
			hasInheritedRestrictions
			hasRestrictions
			hasViewRestrictions
			title
		}
		confluence_publicLinkSpaceHomePage(cloudId: $cloudId, spaceKey: $spaceKey)
			@optIn(to: "AskInCcApiPlatformBeforeUsing") {
			pageId
			pageStatus
		}
	}
`;
